/*
 * @Author       : zxlin
 * @Date         : 2024-03-29 14:32:26
 * @LastEditors  : zxlin
 * @LastEditTime : 2024-03-29 14:51:16
 * @FilePath     : \five-cloth\src\utils\share.js
 * @Description  : 页面加载防止闪动
 */
const option = {
  background: '#fff',
  loadTime: 200,
  offsetTime: 100
}
window.addEventListener('DOMContentLoaded', function () {
  const dom = document.createElement('div')
  dom.className = 'dom-content-load-share'
  document.styleSheets[0].addRule('.dom-content-load-share', `width: 100vw;
    height: 100vh;
    background: ${option.background};
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    transform: translateZ(10000px);
    transition: all ${option.offsetTime}ms;
    `)
  document.body.appendChild(dom)
  setTimeout(() => {
    dom.style.opacity = 0
  }, option.loadTime)
  setTimeout(() => {
    document.body.removeChild(dom)
  }, option.loadTime + option.offsetTime)
})
